module.exports = __webpack_public_path__ + "img/barrenadora.a7ff5c0d.jpg";